import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useTokenParam() {
  const [searchParams] = useSearchParams();
  return useMemo(() => searchParams.get('token') ?? '', [searchParams]);
}
